export default Object.freeze(
  {
    INITIAL: 0,
    LOADING: 1,
    LOADED: 2,
    FAILED: -1
  }
)
